module.exports = __webpack_public_path__ + "static/media/amazon.769d21eb.jpeg";